export const Heading_Section_Product_Engineering = {
    heading: "BUILT FOR THE BEST"
  }
  
  export interface IProductEngineeringStatItem {
    labelLines: string[];
    suffix: string;
    value: string;
  }
  
  export const Stats_Section_Product_Engineering: IProductEngineeringStatItem[] = [
    {
      value: "+60",
      suffix: "%",
      labelLines: ["Avg. Faster Time-to-Market"],
    },
    {
      value: "$10",
      suffix: "M+",
      labelLines: ["CLIENT BUSINESS MANAGED"],
    },
    {
      value: "99",
      suffix: "%",
      labelLines: ["PROJECT SUCCESS RATE"],
    },
  ];
  